import { defineMessages } from 'react-intl';

export const ruleMessages: {
	dashedDivider: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dividerFloatingControls: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dividerOptions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dottedDivider: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	fadeDivider: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	largeDivider: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	mediumDivider: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sketchDivider: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	smallDivider: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	solidDivider: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	style: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	weight: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	dividerOptions: {
		id: 'fabric.editor.rule.dividerOptions',
		defaultMessage: 'Divider options',
		description: 'Label for the floating toolbar button that opens options for a selected divider.',
	},
	dividerFloatingControls: {
		id: 'fabric.editor.rule.dividerFloatingControls',
		defaultMessage: 'Divider floating controls',
		description: 'Accessible title for the floating toolbar shown when a divider is selected.',
	},
	weight: {
		id: 'fabric.editor.rule.weight',
		defaultMessage: 'Weight',
		description: 'Heading for the divider weight options in the divider options menu.',
	},
	style: {
		id: 'fabric.editor.rule.style',
		defaultMessage: 'Style',
		description: 'Heading for the divider style options in the divider options menu.',
	},
	smallDivider: {
		id: 'fabric.editor.rule.smallDivider',
		defaultMessage: 'Small divider',
		description: 'Accessible label for the button that selects a small divider weight.',
	},
	mediumDivider: {
		id: 'fabric.editor.rule.mediumDivider',
		defaultMessage: 'Medium divider',
		description: 'Accessible label for the button that selects a medium divider weight.',
	},
	largeDivider: {
		id: 'fabric.editor.rule.largeDivider',
		defaultMessage: 'Large divider',
		description: 'Accessible label for the button that selects a large divider weight.',
	},
	solidDivider: {
		id: 'fabric.editor.rule.solidDivider',
		defaultMessage: 'Solid divider',
		description: 'Accessible label for the button that selects a solid divider style.',
	},
	dashedDivider: {
		id: 'fabric.editor.rule.dashedDivider',
		defaultMessage: 'Dashed divider',
		description: 'Accessible label for the button that selects a dashed divider style.',
	},
	dottedDivider: {
		id: 'fabric.editor.rule.dottedDivider',
		defaultMessage: 'Dotted divider',
		description: 'Accessible label for the button that selects a dotted divider style.',
	},
	sketchDivider: {
		id: 'fabric.editor.rule.sketchDivider',
		defaultMessage: 'Sketch divider',
		description: 'Accessible label for the button that selects a sketch divider style.',
	},
	fadeDivider: {
		id: 'fabric.editor.rule.fadeDivider',
		defaultMessage: 'Fade divider',
		description: 'Accessible label for the button that selects a fading divider style.',
	},
});
